import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import ROUTES from '@/common/routes';
import { useBreadcrumbs } from '@/modules/core/hooks';
import LettersOfMedicalNecessityViewPage from '@/modules/MyDocuments/components/LettersOfMedicalNecessity/LettersOfMedicalNecessityViewPage';
import { LMNPopupMode } from '@/modules/MyDocuments/myDocuments.types';

const LmnViewMobilePage: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const mode = useMemo(() => {
    return location.pathname.includes('/edit') ? LMNPopupMode.EDIT : LMNPopupMode.VIEW;
  }, [location.pathname]);

  const breadcrumbTitle = mode === LMNPopupMode.EDIT ? t('Edit') : t('View');

  useBreadcrumbs(
    [
      {
        key: ROUTES.HOME,
        title: t('Home'),
        value: ROUTES.HOME,
      },
      {
        key: ROUTES.MY_DOCUMENTS,
        title: t('My Documents'),
        value: ROUTES.MY_DOCUMENTS,
      },
      {
        key: ROUTES.MY_DOCUMENTS_LMN,
        title: t('Letters of Medical Necessity'),
        value: ROUTES.MY_DOCUMENTS_LMN,
      },
      {
        key:
          mode === LMNPopupMode.EDIT
            ? ROUTES.MY_DOCUMENTS_LMN_EDIT_MOBILE()
            : ROUTES.MY_DOCUMENTS_LMN_VIEW_MOBILE(),
        title: breadcrumbTitle,
        value:
          mode === LMNPopupMode.EDIT
            ? ROUTES.MY_DOCUMENTS_LMN_EDIT_MOBILE()
            : ROUTES.MY_DOCUMENTS_LMN_VIEW_MOBILE(),
      },
    ],
    true
  );

  return <LettersOfMedicalNecessityViewPage mode={mode} />;
};

export default LmnViewMobilePage;
